/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell
 */
import Vue, { CreateElement } from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Base from "./base";
import CellCheckbox from "./template/cellCheckbox/cellCheckbox";
import CellDate from "./template/cellDate/cellDate";
import CellSelection from "./template/cellSelection/cellSelection";
import CellIcon from "./template/cellIcon/cellIcon";
import CellImage from "./template/cellImage/cellImage";
import CellSort from "./template/cellSort/cellSort";

@Component({
  components: {
    ["gh-cell-boolean"]: CellCheckbox,
    ["gh-cell-date"]: CellDate,
    ["gh-cell-selection"]: CellSelection,
    ["gh-cell-icon"]: CellIcon,
    ["gh-cell-image"]: CellImage,
    ["gh-cell-O-sort"]: CellSort
  }
})
export default class VuetifyCell extends Base {
  private els = {
    ["boolean"]: "gh-cell-boolean",
    ["date"]: "gh-cell-date",
    ["selection"]: "gh-cell-selection",
    ["icon"]: "gh-cell-icon",
    ["image"]: "gh-cell-image",
    ["O-sort"]: "gh-cell-O-sort"
  };
  render(h: CreateElement) {
    let type = this.prop.type as string;
    if (this.els[type]) {
      return h(this.els[type], {
        props: {
          prop: this.prop,
          model: this.model,
          index: this.index,
          multiple: this.multiple
        }
      });
    } else {
      let value = eval("this.model." + this.prop.value);
      return h("span", {}, value);
    }
  }
}
